import React, { useMemo } from "react";
import { Row, Col, Slider, InputNumber, Typography, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { COLORS } from "../../../../../../layout/theme";

const clamp01 = (x) => Math.max(0, Math.min(1, x));

export default function WeightMixer({ value, onChange }) {
	const v = value ?? {
		weightOOS: 0.4,
		weightRecency: 0.25,
		weightFrequency: 0.2,
		weightRecovery: 0.0,
		weightLabCuration: 0.15,
	};

	const total =
		v.weightOOS +
		v.weightRecency +
		v.weightFrequency +
		v.weightRecovery +
		v.weightLabCuration;
	const remaining = 1 - total;

	const set = (key, newRaw) => {
		const newVal = clamp01(newRaw);
		const othersKeys = [
			"weightOOS",
			"weightRecency",
			"weightFrequency",
			"weightRecovery",
			"weightLabCuration",
		].filter((k) => k !== key);
		const othersSum = othersKeys.reduce((s, k) => s + v[k], 0);
		const toDistribute = clamp01(1 - newVal);

		let res = { ...v, [key]: newVal };

		if (othersSum === 0) {
			const each = toDistribute / othersKeys.length;
			othersKeys.forEach((k) => (res[k] = each));
		} else {
			othersKeys.forEach((k) => {
				const share = v[k] / othersSum;
				res[k] = clamp01(share * toDistribute);
			});
		}

		const fix = (x) => Math.round(x * 1000) / 1000;
		res.weightOOS = fix(res.weightOOS);
		res.weightRecency = fix(res.weightRecency);
		res.weightFrequency = fix(res.weightFrequency);
		res.weightRecovery = fix(res.weightRecovery);
		res.weightLabCuration = fix(res.weightLabCuration);

		onChange?.(res);
	};

	const items = [
		{
			key: "weightOOS",
			label: "Faltantes",
			explanation:
				"'Fuera de stock', detecta quiebres (pendientes en los pedidos).",
		},
		{
			key: "weightRecency",
			label: "Recencia",
			explanation:
				"Recomendados básico, detecta qué tan presente está el producto en el carro de la farmacia, cuando además es frecuente.",
		},
		{
			key: "weightFrequency",
			label: "Frecuencia",
			explanation:
				"Regularidad de compra, identifica hábitos de compra repetitivos.",
		},
		{
			key: "weightRecovery",
			label: "Recupero",
			explanation:
				"Detecta productos que hace mucho que no compra aunque solía comprarlos.",
		},
		{
			key: "weightLabCuration",
			label: "Destacados",
			explanation: "Fuerza productos elegidos por el laboratorio.",
		},
	];

	return (
		<div>
			{items.map(({ key, label, explanation }) => (
				<Row key={key} gutter={8} align="middle" style={{ marginBottom: 8 }}>
					<Col span={5}>
						<Tooltip
							title={`${explanation}`}
							placement="topLeft"
							arrowPointAtCenter
						>
							<InfoCircleOutlined
								style={{ color: COLORS.Secondary, paddingRight: 10 }}
							/>
						</Tooltip>
						<Typography.Text>{label}</Typography.Text>
					</Col>
					<Col span={12}>
						<Slider
							min={0}
							max={1}
							step={0.01}
							value={v[key]}
							onChange={(val) => set(key, val)}
						/>
					</Col>
					<Col span={7}>
						<InputNumber
							min={0}
							max={1}
							step={0.01}
							style={{ width: "100%" }}
							value={v[key]}
							onChange={(val) => set(key, Number(val ?? 0))}
						/>
					</Col>
				</Row>
			))}
		</div>
	);
}
